import { Coordinate } from './addressModels';

export default class SearchAddressWithUserCoordsModel {
    address: string;
    userCoordinates: Coordinate | undefined;

    constructor(sacm?: Partial<SearchAddressWithUserCoordsModel>) {
        this.address = sacm?.address ?? '';
        this.userCoordinates = sacm?.userCoordinates ?? undefined;
    }
    get asString() {
        return this.address + ' | ' + this.userCoordinates;
    }
}
